var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Banner'),_c('About',{attrs:{"aboutData":_vm.config.manageHome.about}}),_c('Student'),_c('Course'),_c('News'),_c('Event',{attrs:{"eventData":_vm.config.manageHome.event}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }